import filtersList from "@/assets/data/filtersList";
import _truncate from "lodash/truncate";
import { HorizontalBar } from "./BaseCharts";
import { mapActions } from "vuex";
import { chunck } from "./plugins/plugins";

export default {
  extends: HorizontalBar,
  data() {
    return {};
  },
  props: {
    datos: Array,
    filterValue: String,
    yAxisLabelTruncateLength: {
      type: Number,
      default: 0
    },
    yAxisLabelTruncateSeparator: {
      type: String,
      default: " [...]"
    }
  },
  methods: {
    ...mapActions(["addFilterAction"]),
    createChart() {
      const that = this;
      var numeral = require("numeral");
      this.renderChart(
        {
          labels: this.datos.map(function(el) {
            return el.label;
          }),
          datasets: [
            {
              label: "PRESUPUESTADO",
              //backgroundColor: "#9575CD",
              backgroundColor: "#5D4DF7",
              data: this.datos.map(function(el) {
                return el.presupuesto_2019;
              })
            },
            {
              label: "EJECUTADO",
              //backgroundColor: "#D1C4E9",
              backgroundColor: "#82B1FF",
              data: this.datos.map(function(el) {
                return el.ejecutado_2019;
              })
            }
          ]
        },
        {
          responsive: true,
          maintainAspectRatio: false,
          animation: false,
          layout: {
            padding: {
              bottom: 40
            }
          },
          tooltips: {
            titleFontSize: 14,
            caretSize: 0,
            bodyFontSize: 16,
            callbacks: {
              label: function(tooltipItem) {
                return numeral(tooltipItem.xLabel).format("$ 0,0.00");
              },
              title: function(tooltipItems, data) {
                var idx = tooltipItems[0].index;
                return data.labels[idx]; //do something with title
              }
            }
          },
          scales: {
            yAxes: [
              {
                ticks: {
                  callback: function(value) {
                    if (that.yAxisLabelTruncateLength > 0) {
                      return _truncate(value, {
                        length: that.yAxisLabelTruncateLength,
                        separator: that.yAxisLabelTruncateSeparator
                      });
                    } else return value;
                  }
                }
              }
            ],
            xAxes: [
              {
                ticks: {
                  callback: function(value) {
                    return "$" + numeral(value).format("0a");
                  }
                }
              }
            ]
          },
          onClick: function(evt, item) {
            // console.log(evt, item)

            if (item.length) {
              let filter = Object.assign(
                {},
                filtersList.find(function(element) {
                  return element.field.value === that.filterValue;
                })
              );
              console.log("filter.field.component", filter.field.component);
              var keyword = item[0]._model.label.join("");
              if (filter.field.component == "datatable") {
                filter.field.context = "filter";
                filter.param = keyword;
              } else {
                filter.param = [keyword];
              }
              try {
                that.addFilterAction(filter);
              } catch (e) {
                console.log(e);
              }
            }
          }
        }
      );
    }
  },
  watch: {
    datos: {
      handler: function() {
        this.createChart();
      },
      deep: true
    }
  },
  mounted() {
    this.addPlugin(chunck);
    this.createChart();
  }
};
